import WebApi from "@/views/loyalty/shared/modules/web_api"

export class PaymentEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_LOYALTY_URL}api/payment/`
        this.webApi = new WebApi()
    }

    async get_payment (item) {
        const payment = await this.webApi.post(`${this.url}`, { item: item })
        return payment
    }

    async get_payments (page, limit, filter, search) {
        const payments = await this.webApi.post(`${this.url}`, {
            page: page,
            limit: limit,
            filter: filter,
            search: search
        })
        console.log('get_payments', payments)
        if (!payments.status_code) {
            return payments
        } else {
            console.error(`Ошибка с кодом: ${payments.status_code}`)
        }
    }
}
